<template>
  <div>
    <filter-item>
      <form-field-select
        label="Timeframe"
        v-model="timeFrame"
      >
        <option
          v-for="option in timeFramesOptions"
          :value="option.value"
          :key="option.value"
        >{{ option.label }}
        </option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <form-field-date-picker
        v-if="timeFrame === 'custom'"
        label="Custom Timeframe"
        v-model="timeFrameCustomValues"
        is-range
      ></form-field-date-picker>
    </filter-item>

    <filter-item v-if="isOwner">
      <form-field-checkbox-group
        label="Users"
        is-sidebar-filter
        :items="activeUsers"
        v-model="users"
        @selectAll="selectAllUsers"
        @deselectAll="deselectAllUsers"
      ></form-field-checkbox-group>
    </filter-item>
  </div>
</template>

<script>
import {timeFrames} from "../../../services/staticData";
import dates from "../../../services/dates";

export default {
  name: "StatsTeamFilter",
  data() {
    return {
      timeFrame: null,
      timeFrameValues: {
        start: null,
        end: null,
      },
      timeFrameCustomValues: [],
      users: []
    }
  },
  mounted() {
    this.resetFilter()
  },
  computed: {
    authUser() {
      return this.$store.getters.authUser
    },
    isOwner() {
      return this.authUser.is_owner
    },
    timeFramesOptions() {
      return [
        ...timeFrames,
        { value: 'custom', label: 'Custom', start: null, end: null },
      ]
    },
    activeUsers() {
      return this.$store.getters.activeUsers.map(user => {
        return {
          id: user.id,
          label: user.full_name
        }
      })
    }
  },
  methods: {
    applyFilter() {
      const timeFrameValue = timeFrames.find(t => t.value === this.timeFrame)
      if (timeFrameValue) {
        this.timeFrameValues = {
          start: timeFrameValue.start,
          end: timeFrameValue.end,
        }
      } else {
        this.timeFrameValues = {
          start: dates.convertJsDateToStartOf(this.timeFrameCustomValues[0]),
          end: dates.convertJsDateToEndOf(this.timeFrameCustomValues[1]),
        }
      }

      this.$store.commit('statsTeam/setOneFilter', ['timeFrame', this.timeFrame])
      this.$store.commit('statsTeam/setOneFilter', ['timeFrameValues', this.timeFrameValues])
      this.$store.commit('statsTeam/setOneFilter', ['users', this.users])
    },
    resetFilter() {
      // sets users to auth user when auth user is not an owner
      if (!this.isOwner) {
        this.users = [this.authUser.id]
        this.$store.commit('statsTeam/setOneFilter', ['users', this.users])
      }

      this.timeFrame = this.$store.getters['statsTeam/getFilters'].timeFrame
      this.timeFrameValues = this.$store.getters['statsTeam/getFilters'].timeFrameValues
      this.users = this.$store.getters['statsTeam/getFilters'].users

      if (this.timeFrame === 'custom') {
        this.timeFrameCustomValues = [
          dates.getJSDate(this.timeFrameValues.start),
          dates.getJSDate(this.timeFrameValues.end)
        ]
      }
    },
    selectAllUsers() {
      this.users = this.activeUsers.map(user => user.id)
    },
    deselectAllUsers() {
      this.users = []
    },
  },
}
</script>

<style scoped lang="scss">

</style>
